import React from 'react';

import { SkipLink } from './styles';

function SkipToContent() {
  return (
    <SkipLink href="#content" className="skip-to-content">
      Skip to Content
    </SkipLink>
  );
}

export default SkipToContent;
